__webpack_require__.p = "/apps/announcementcenter/js/";